import { parseAsString, useQueryState } from 'nuqs';
import React, { ReactElement } from 'react';
import { useDebounce } from 'use-debounce';

import { Novelties } from 'src/features/novelties/Novelties';

export function NoveltiesContainer(): ReactElement {
  const [search, setSearch] = useQueryState(
    'search',
    parseAsString.withDefault(''),
  );
  const [debouncedSearch] = useDebounce(search, 300);

  return (
    <Novelties
      search={debouncedSearch}
      localSearch={search}
      setSearch={setSearch}
    />
  );
}
